<fieldset *ngIf="!props.hidden"
  class="border mx-0 mb-2"
  [ngClass]="props.className"
  [ngStyle]="{'margin-top': props.label ? 'inherit' : '10px' }">
  <legend *ngIf="props.label"
    class="form-label px-1">{{ props.label }}</legend>
  <ng-container #fieldComponent></ng-container>

  <div *ngIf="showError"
    class="invalid-feedback"
    [style.display]="'block'">
    <formly-validation-message [field]="field"></formly-validation-message>
  </div>

</fieldset>